import { render, staticRenderFns } from "./OcorrenciaJustificada.vue?vue&type=template&id=66b27956&"
import script from "./OcorrenciaJustificada.vue?vue&type=script&lang=js&"
export * from "./OcorrenciaJustificada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports